// extracted by mini-css-extract-plugin
export default {"PlusIcon":"ExpandedStatus_PlusIcon__ztqs1"};